import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './template.types';
import * as constants from './template.constants';

export const storeTemplate = generateStoreResourceAction<types.ITemplate>(constants.STORE_TEMPLATE);
export const clearTemplate = generateClearResourceAction(constants.CLEAR_TEMPLATE);
